import axios from "axios";

const DOCX_SERVICE_URL =
  import.meta.env.MODE && import.meta.env.MODE === "development"
    ? `${import.meta.env.VITE_REPORTS_API_URL}/reports/`
    : "/reports/";

const docxClient = axios.create({
  baseURL: DOCX_SERVICE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export { docxClient };